module.exports = __webpack_public_path__ + "img/signo-admiracion.511bb3e7.svg";